import React from 'react';
import { MiniCheck, MiniNum } from './ControlPanelHelpers';

const CertsTab = ({ certificationFilters, setCertificationFilters, certMinWords, setCertMinWords, contentMinWords, setContentMinWords }) => (
  <div data-testid="cp-cert-panel">
    <div style={{ fontSize: '0.5rem', color: '#ef4444', marginBottom: 4 }}>CERTIFICATION FILTERS &middot; unchecked = no paid-access blurbs</div>
    {[
      { key: 'pearsonvue', label: 'PearsonVUE Certified', color: '#FDE047' },
      { key: 'government', label: 'Government Source', color: '#ef4444' },
      { key: 'advancedDegree', label: 'Advanced Degree (PhD/Masters)', color: '#3b82f6' }
    ].map(f => (
      <div key={f.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '3px 0', borderBottom: '1px solid rgba(253, 230, 138,0.04)' }}>
        <MiniCheck checked={certificationFilters[f.key]} color={f.color}
          onChange={() => setCertificationFilters(p => ({ ...p, [f.key]: !p[f.key] }))}
          label={f.label} />
        <MiniNum value={certMinWords[f.key] || 0}
          onChange={v => setCertMinWords(p => ({ ...p, [f.key]: v }))} />
      </div>
    ))}
    <div style={{ marginTop: 8, fontSize: '0.5rem', color: '#555', marginBottom: 4 }}>CONTENT PREFERENCE &middot; min words</div>
    {Object.keys(contentMinWords).map(ct => (
      <div key={ct} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0', borderBottom: '1px solid rgba(253, 230, 138,0.04)' }}>
        <span style={{ color: '#71717a', fontSize: '0.55rem' }}>{ct.charAt(0).toUpperCase() + ct.slice(1)}</span>
        <MiniNum value={contentMinWords[ct] || 0}
          onChange={v => setContentMinWords(p => ({ ...p, [ct]: v }))} />
      </div>
    ))}
  </div>
);

export default CertsTab;
